export default `/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([suppress-error-message]) .validation-message {
  display: none;
}

:host ids-popup {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-popup {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-popup {
  max-width: calc(var(--ids-input-width-20));
}

:host([size=mm]) ids-popup {
  max-width: calc(var(--ids-input-width-30));
}

:host([size=md]) ids-popup {
  max-width: calc(var(--ids-input-width-40));
}

:host([size=lg]) ids-popup {
  max-width: calc(var(--ids-input-width-50));
}

:host([size=full]) ids-popup {
  max-width: var(--ids-input-width-full);
}

:host ids-popup,
:host([size=full]) {
  width: 100%;
}

:host([position-style=fixed]) {
  display: block;
}

:host(.input-auto-size-false) ids-popup {
  width: fit-content;
  max-width: calc(100% - 40px);
}

:host(.input-auto-size-false.multi-column) ids-popup {
  max-width: calc(100vw - 40px);
}

:host(.input-auto-size-false) ids-popup::part(popup) {
  border-top: 1px solid var(--ids-input-color-border-focus);
}

:host(.input-auto-size-false[multi-column]) ids-popup::part(content-wrapper) {
  overflow: visible;
}

.multiselect-footer {
  display: flex;
  gap: var(--ids-space-12);
  padding: var(--ids-multiselect-footer-padding);
  justify-content: flex-end;
}
.multiselect-footer .multiselect-btn {
  width: 100%;
}

::slotted(ids-list-box.mobile-auto-size) {
  overflow-x: auto;
  display: block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
